/**
 * 搜索
 */
import reqwest from 'reqwest';
export default {
  /**
   * 百度搜索建议
   * @param params
   * @param callback
   */
  getBaiduSuggest (params, callback) {
    reqwest({
      url: 'https://www.baidu.com/su?',
      data: params,
      type: 'jsonp',
      jsonpCallback: 'cb',
      timeout: 300
    })
    .then(val => callback(null, val))
    .catch(e => callback(e))
  },
  /**
   * 360搜索
   * @param text
   */
  search360 (text) {
    var searchUrl = 'https://www.so.com/'
    window.parent.location.href = searchUrl + 's?ie=utf-8&q=' + text + '&src=zh&ls=pclm2345w_8'
  },
  /**
   * 百度搜索
   * @param text
   */
  searchBaidu (text) {
    // https://www.baidu.com/s?tn=25017023_7_dg&ch=1&ie=UTF-8&wd=12306
    var searchUrl = 'https://www.baidu.com/'
    var searchWord = text.length > 0 ? 'word=' + text : ''
    window.parent.location.href = searchUrl + 's?' + searchWord + '&tn=25017023_7_dg'
  }
}
